<div class="text_black border_wrapper h-100 powertrain_wrapper summaryBox" style="margin-bottom:8px">
  <div
    class="p-2 d-flex align-items-center justify-content-center text-black h_25"
    style="
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    "
  >
    <h4 class="font-weight-bolder powertrain_headers">
      {{sub_name}} Anomaly Status
    </h4>
  </div>
  <div class="d-flex h_75" style="justify-content: space-around">
    <div class="mt-1 mt-md-2 mr-2 mr-md-4 flex flex_50 gap_10">
      <div class="column_response_text_left w-100 h_20 p_2">Updated at</div>
      <div class="column_response_text_left w-100 h_20 p_2">Status</div>
      <div class="column_response_text_left w-100 h_20 p_2">Recommended Action</div>
      <div class="column_response_text_left w-100 h_20 p_2" *ngIf="!BHEL_ON_PREM">Download Report</div>
    </div>
    <div class="mt-1 mt-md-2 mr-2 mr-md-4 flex flex_50 gap_10" *ngIf="!anomaly_status_loader">
      <div class="column_response_text_right h_20 p_2">
        {{ anomaly_status.timeUpdatedAt }}
      </div>
      <div
        class="column_response_text_right h_20 p_2"
        [ngClass]="statusClass"
        style="display: flex; align-items: center; justify-content: center;"
      >
        {{ overall_live_status=='2' ? 'Asset Idle' : anomaly_status.overall_status }}
      </div>
      <div class="column_response_text_right h_20 p_2">
        {{ anomaly_status.action_required }}
      </div>
      <div class="column_response_text_right h_20 p_2" *ngIf="!BHEL_ON_PREM">
        <button mat-raised-button color="primary" (click)="openReportModal()">
          Generate Report
        </button>
      </div>
    </div>
    <div class="mt-2 mt-md-1 mr-2 mr-md-4 flex flex_50 gap_10" *ngIf="anomaly_status_loader">
      <div class="h_20 p_2 skeleton skeleton-text w-100"></div>
      <div class="h_20 p_2 skeleton skeleton-text w-100"></div>
      <div class="h_20 p_2 skeleton skeleton-text w-100"></div>
      <div class="h_20 p_2 skeleton skeleton-text w-100"></div>
    </div>
  </div>
</div>

<!-- Modal for Report Generation -->
<div class="modal-backdrop fade show" *ngIf="isReportModalOpen"></div>

<div class="modal-overlay" *ngIf="isReportModalOpen" [@fadeInOut]>
  <div class="modern-modal" [@slideInOut]>
    <div class="modal-content">
      <div class="modal-header" [class.processing]="isLoading">
        <h4 class="modal-title">
          <span *ngIf="isLoading">{{ processingStepText }}</span>
          <span *ngIf="!isLoading">Report Ready</span>
        </h4>
        <button *ngIf="!isLoading" class="close-button" mat-icon-button (click)="closeReportModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="isLoading" class="loading-container">
          <div class="progress-tracker">
            <div class="progress-bar" [style.width.%]="progressPercentage"></div>
          </div>
          <div class="animated-process-container">
            <div class="process-step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
              <div class="step-icon-container">
                <div class="step-icon data-collection" [class.animate]="currentStep === 1">
                  <div class="data-point" *ngFor="let i of [1,2,3,4,5]"></div>
                  <div class="collector"></div>
                </div>
                <div class="step-check" *ngIf="currentStep > 1">
                  <mat-icon>check</mat-icon>
                </div>
              </div>
              <div class="step-details">
                <h6>Collecting Data</h6>
                <p *ngIf="currentStep === 1">Gathering piezo sensor metrics...</p>
                <p *ngIf="currentStep > 1">Data collection complete</p>
              </div>
            </div>

            <div class="process-step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2" [class.upcoming]="currentStep < 2">
              <div class="step-icon-container">
                <div class="step-icon sa-demand" [class.animate]="currentStep === 2">
                  <div class="sa-icon"></div>
                </div>
                <div class="step-check" *ngIf="currentStep > 2">
                  <mat-icon>check</mat-icon>
                </div>
              </div>
              <div class="step-details">
                <h6>Performing Report Generation</h6>
                <p *ngIf="currentStep === 2">Generating Report...</p>
                <p *ngIf="currentStep > 2">Report Generation Completed</p>
              </div>
            </div>

            <div class="process-step" [class.active]="currentStep === 3" [class.upcoming]="currentStep < 3">
              <div class="step-icon-container">
                <div class="step-icon finalizing" [class.animate]="currentStep === 3">
                  <div class="polish-effect"></div>
                </div>
              </div>
              <div class="step-details">
                <h6>Report Generated</h6>
                <p *ngIf="currentStep === 3">Finalizing report...</p>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!isLoading" class="success-container" [@bounceIn]>
          <div class="success-icon-container">
            <div class="success-pulse"></div>
            <div class="success-icon">
              <mat-icon>check_circle</mat-icon>
            </div>
          </div>
          <h5 class="status-title">Report Ready</h5>
          <p class="status-message">Your piezo sensor report has been generated successfully.</p>
          <div class="report-preview">
            <div class="preview-document">
              <div class="preview-header"></div>
              <div class="preview-content">
                <div class="preview-line"></div>
                <div class="preview-line"></div>
                <div class="preview-chart"></div>
                <div class="preview-line short"></div>
                <div class="preview-line"></div>
              </div>
            </div>
          </div>
          <div class="report-actions">
            <button mat-flat-button color="primary" (click)="downloadReport()" class="download-btn" [disabled]="isDownloading">
              <div class="button-content">
                <mat-spinner *ngIf="isDownloading" [diameter]="20" class="spinner"></mat-spinner>
                <mat-icon *ngIf="!isDownloading">download</mat-icon>
                <span *ngIf="!isDownloading">Download Report</span>
              </div>
            </button>
            <button mat-stroked-button color="primary" (click)="previewReport()">
              <mat-icon>visibility</mat-icon>
              Preview
            </button>
          </div>
          <div class="report-meta">
            <div class="meta-item">
              <mat-icon>access_time</mat-icon>
              <span>Generated {{ today | date:'medium' }}</span>
            </div>
            <div class="meta-item">
              <mat-icon>insert_drive_file</mat-icon>
              <span>PDF Format • {{ reportSize }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer" *ngIf="!isLoading">
        <button mat-button (click)="closeReportModal()">Close</button>
      </div>
    </div>
  </div>
</div>